import { RootState } from '../../store/root-state';

export const getGroupsState = (state: RootState) => state.groups.groups;
